import { BaseResource } from '../core/base-resource';

export class PlacedOrderCustomer extends BaseResource {
  email: string;
  name: string;
  subscribed: string;
}
